import { render, staticRenderFns } from "./DealNeopag.vue?vue&type=template&id=4c97688b&"
import script from "./DealNeopag.vue?vue&type=script&lang=js&"
export * from "./DealNeopag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports